import React from 'react';
import {
  StandardNotification,
  NotificationType,
} from '@is24at/react-notifications';
import RLEEntryPoint from '../RLEEntryPoint';
import styles from './NoResults.scss';

interface NoResultsProps {
  noHits?: boolean;
}

const NoResults = ({ noHits = false }: NoResultsProps) =>
  noHits && (
    <>
      <section className={styles['no-hits']}>
        <StandardNotification
          data={{
            title: 'Keine Treffer',
            content: 'Wähle ein größeres Gebiet',
          }}
          dismissAfter={0}
          type={NotificationType.INFO}
        />
      </section>
      <RLEEntryPoint withNegativeMargin={false} />
    </>
  );

export default NoResults;
